const IN_APP_OPEN_ATTEMPTED_KEY = 'mx_in_app_browser_open_attempted';

export const IN_APP_BROWSER_MESSAGE =
  'Please open this page in Safari or Chrome to continue.';

export const checkInAppBrowser = () => {
  if (typeof window === 'undefined') return false;
  const ua = navigator?.userAgent;
  if (!ua) return false;
  const inApp = new RegExp(
    /FB[\w_]|Messenger|MESSENGER|Instagram|Twitter|TikTok/g
  ).test(ua);
  return inApp;
};

/**
 * Best-effort: open the current page in a new tab (once per session).
 * Never reloads in-place (same-URL navigation loops in in-app browsers).
 * @returns true if a new tab/window was opened, false if blocked or already attempted.
 */
export function promptOpenInExternalBrowser(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    if (sessionStorage.getItem(IN_APP_OPEN_ATTEMPTED_KEY)) return false;
    sessionStorage.setItem(IN_APP_OPEN_ATTEMPTED_KEY, '1');
    const newWindow = window.open(
      window.location.href,
      '_blank',
      'noopener,noreferrer'
    );
    return newWindow != null;
  } catch {
    return false;
  }
}

export type InAppBrowserGate = 'proceed' | 'opened_external';

/**
 * In-app browser guard aligned with loginSocialRedirect:
 * - proceed: not in-app, caller continues
 * - opened_external: new tab opened; caller should stop without error
 * - throws: popup blocked / already attempted
 */
export function gateInAppBrowser(
  message = IN_APP_BROWSER_MESSAGE
): InAppBrowserGate {
  if (!checkInAppBrowser()) return 'proceed';
  if (promptOpenInExternalBrowser()) return 'opened_external';
  throw new Error(message);
}
